import Modal from "@mui/material/Modal";
import { FC } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { Certificate } from "crypto-pro";
import Typography from "@mui/material/Typography";
import { getDateTime } from "../lib/utils";
import CloseIcon from "@mui/icons-material/Close";
import { StyledcertificateBox } from "./styled";
import IconButton from "@mui/material/IconButton";
import { CircularProgress } from "@mui/material";

const CertificateModal: FC<{
  open: boolean;
  handleClose: () => void;
  handleSelectedCertificateForSign: (certificate: Certificate) => void;
  certificates: Certificate[];
  isLoadingApprove?: boolean;
}> = ({
  open,
  handleClose,
  handleSelectedCertificateForSign,
  certificates,
  isLoadingApprove,
}) => {
  const handleSelectCertificate = (certificate: Certificate) => {
    handleSelectedCertificateForSign(certificate);
    handleClose();
  };

  return (
    <Modal open={isLoadingApprove || open} onClose={handleClose}>
      {isLoadingApprove ? (
        <Box
          display="flex"
          width="100%"
          height="100%"
          justifyContent="center"
          alignItems="center"
        >
          <Box p={2} sx={{ backgroundColor: "white" }}>
            <CircularProgress />
          </Box>
        </Box>
      ) : (
        <Box
          display="flex"
          width="100%"
          height="100%"
          justifyContent="center"
          alignItems="center"
        >
          <Paper
            sx={{
              width: "70%",
              height: 550,
              padding: "16px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "24px",
            }}
          >
            <Box
              display="flex"
              flexDirection="column"
              width="100%"
              height={500}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                paddingX={2}
                borderBottom={1}
              >
                <Typography variant="h5">Список сертификатов:</Typography>
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
              <Box sx={{ overflowY: "scroll" }}>
                {certificates.map((certificate) => (
                  <StyledcertificateBox
                    key={certificate.name}
                    onClick={() => handleSelectCertificate(certificate)}
                  >
                    <Typography>{certificate.subjectName};</Typography>
                    <Typography noWrap flexShrink={0}>
                      Выдан: {getDateTime(new Date(certificate.validFrom))}
                    </Typography>
                  </StyledcertificateBox>
                ))}
              </Box>
            </Box>
          </Paper>
        </Box>
      )}
    </Modal>
  );
};

export default CertificateModal;
